import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

@Component({
    selector: 'eci-reported-tax-reports',
    templateUrl: './reported-tax-reports.component.html',
    styleUrls: ['./reported-tax-reports.component.scss']
})
export class ReportedTaxReportsComponent implements OnInit {
    companyId = null;
    links = [
        {
            name: 'OSS',
            link: 'oss'
        },
        {
            name: 'IOSS',
            link: 'ioss'
        },
        {
            name: 'UK',
            link: 'uk'
        },
        {
            name: 'Regular',
            link: 'regular'
        },
        {
            name: 'Purchases',
            link: 'purchases'
        }
    ]

    activeLink = this.links[0].link;

    constructor(
        public router: Router,
    ) {}

    ngOnInit(): void {
        const selectedUrl = this.router.url.split('/');
        this.activeLink = selectedUrl[selectedUrl.length - 1];
    }
}
